module.exports = __webpack_public_path__ + "img/aboutApp1.11a8ca22.png";